export interface UserProfile {
  id: number;
  emailAddress: string;
  firstName: string;
  lastName: string;
  mobileNumber: string;
  status: string;
  profilePictureFileName: string | null;
  role?: string;
  roleUserId?: string;
  roleId?: string;
  roleName?: string;
}

export interface UserProfileState {
  profile: UserProfile | null;
  isLoading: boolean;
  error: string | null;
  isChangingPassword: boolean;
  changePasswordError: string | null;
  changePasswordSucceeded: boolean;
}

export const initialUserProfileState: UserProfileState = {
  profile: null,
  isLoading: false,
  error: null,
  isChangingPassword: false,
  changePasswordError: null,
  changePasswordSucceeded: false,
};
